import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-home-five',
  templateUrl: './home-five.component.html',
  styleUrls: ['./home-five.component.css']
})
export class HomeFiveComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
